<section class="mt-2">
    <span><button class="btn btn-secondary mt-2" (click)="openProductCharForAddEdit(profileCharacter)"><i
                class="fa fa-plus-circle" aria-hidden="true"></i> Add</button></span>
    <table class="table table-hover white_box shadow" style="margin-top: 10px;">
        <thead>

            <tr>
                <th scope="col">#</th>
                <th scope="col">Image</th>
                <th scope="col">Description</th>
                <th scope="col">Price</th>
                <th scope="col">URL</th>
                <th scope="col">Category</th>
                <th scope="col">Sub-Region</th>
                <th scope="col" class="text-center">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of allAds; let i = index;">
                <th scope="row">{{i + 1}}</th>
                <td> <img loading="lazy" style="height: 5rem;" [src]="imgUrl + item.image"></td>
                <td>{{item?.description}}</td>
                <td><span>{{item?.price}}</span></td>
                <td>{{item?.url }}</td>
                <td>
                    <div class="row">
                        <ng-container *ngFor="let c of item?.categoryList">
                            <span class="sub-cate p-2 m-2 "> {{c}}</span>
                        </ng-container>
                    </div>
                </td>
                <td>
                    <div class="row">
                        <ng-container *ngFor="let s of  item?.subRegionList">
                            <span class="sub-cate p-2 m-2">{{ s }}</span>
                        </ng-container>
                    </div>
                </td>
                <td class="text-right">
                    <section class="d-flex justify-content-center">
                        <button class="btn btn-info" (click)="openProductCharForAddEdit(profileCharacter,item)">
                            <i class="fa fa-pencil" aria-hidden="true"></i>
                            Edit
                        </button>
                        <button class="btn btn-secondary ml-2" (click)="openModal(item)"><i class="fa fa-users"
                                aria-hidden="true"></i> Assign</button>
                        <button class="btn btn-danger  ml-2" (click)="deleteAds(item?.id)">
                            <i class="fa fa-trash" aria-hidden="true"></i> Delete
                        </button>
                    </section>
                </td>
            </tr>
        </tbody>
    </table>
</section>

<ng-template #profileCharacter let-modal>
    <div id="add_prod_detail" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class=""></div>
        <div class="modal-body">
            <form [formGroup]="form">

                <div class="form-group col-12">
                    <label for="Description">Description</label>
                    <textarea type="text" formControlName="description" class="form-control" id="Description" rows="5"
                        aria-describedby="emailHelp" placeholder="Enter Description"></textarea>
                </div>

                <div class="form-group col-12">
                    <label for="exampleInputEmail1">Price </label>
                    <input type="text" formControlName="price" class="form-control" id="exampleInputEmail1"
                        aria-describedby="emailHelp" placeholder="Enter Price">
                </div>

                <div class="form-group col-12">
                    <label for="exampleInputEmail1">URL </label>
                    <input type="text" formControlName="url" class="form-control" id="exampleInputEmail1"
                        aria-describedby="emailHelp" placeholder="Enter URL">
                </div>

                <img loading="lazy" *ngIf="imageBase64" class="map-search-listing-img mt-2 product-char-image" [src]="imageBase64"
                    alt="" />
                <img loading="lazy" *ngIf="selectedAds?.image" class="map-search-listing-img mt-2 product-char-image"
                    [src]="imgUrl + selectedAds?.image">

                <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()">
                    <i class="fas fa-plus"></i> Upload Picture
                </button>
                <input type="file" #upload (change)="saveProductCharSelectedImage($event)"
                    class="suggestion-modal-pic-input d-none" accept="image/*" />


                <div class="mt-3 text-right">
                    <button class="btn btn-secondary mr-2" (click)="modalDismissAll()">
                        <i class="fa-solid fa-times"></i> Cancel
                    </button>
                    <button class="btn btn-primary" (click)="saveAds()">
                        <i class="fa-solid fa-save"></i> Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #AssignOption let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Assign</h4>
        <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
    </div>
    <div class="modal-body">
        <section>
            <div>Category : </div>
            <div class="my-4 row d-flex justify-content-center">
                <ng-container *ngFor="let c of categoriesList">
                    <span class="sub-cate p-2 m-2 "> <input type="checkbox" [(ngModel)]="c.checked" />
                        {{c.name}}</span>
                </ng-container>
            </div>
        </section>

        <section>
            <div>Sub Region :</div>
            <div class="my-4 row d-flex justify-content-center">
                <ng-container *ngFor="let s of subRegionList">
                    <span class="sub-cate p-2 m-2">
                        <input type="checkbox" [(ngModel)]="s.checked" /> {{ s.name }}</span>
                </ng-container>
            </div>
        </section>

        <duv class="d-flex justify-content-end">
            <button type="button" class="btn btn-secondary" (click)="assignArticles()">
                Assign
            </button>
        </duv>
    </div>
</ng-template>